import axiosInstance from "../../../../../axiosInstance";

const useDownloadImage = () => {
  return ({path, filename}) => {
    let Req = {
      method: "GET",
      url: window.localStorage.getItem("BaseURL") + path,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axiosInstance(Req)
      .then((Res) => {
        // Extract the file extension from the imageUrl
        const extension = path.split(".").pop().split("?")[0]; // Handle cases where there might be query params
        // Ensure the blob has the correct MIME type based on the extension
        const blob = new Blob([Res.data], {type: `image/${extension}`});
        // Create a URL for the Blob
        const url = URL.createObjectURL(blob);
        // Create an anchor element
        const link = document.createElement("a");
        link.href = url;
        link.download = `${filename}.${extension}`; // Set the desired file name with the correct extension
        // Trigger a click on the anchor element
        link.click();
        // Release the URL object
        URL.revokeObjectURL(url);
      })
      .catch((Err) => {
        console.log(Err);
      });
  }
}

export default useDownloadImage;
